import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, MapPin, Phone } from 'lucide-react';
import { BUSINESS, IMAGES } from './data';
export function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitted(true);
  };
  return <section id="contact" className="w-full bg-secondary py-20 sm:py-24" data-id="element-10" data-mp="36o28y16cv38s">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-11" data-mp="79yudm3j893r">
        <div className="overflow-hidden rounded-3xl border border-border bg-card shadow-sm" data-id="element-12" data-mp="38wq2qurd6ux">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-13" data-mp="3ueoi5vs3itkd">
            <div className="relative hidden lg:block" data-id="element-14" data-mp="3uhappvezl92l">
              <img src={IMAGES.patio} alt="Finished paver patio surrounded by turf" className="absolute inset-0 h-full w-full object-cover" data-id="element-15" data-mp="3pfl9m1cwq57n" />
              <div className="absolute inset-0 bg-brand-ink/30" data-id="element-16" data-mp="2e0g830oiicpm" />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-ink via-brand-ink/80 to-brand-ink/35" data-id="element-17" data-mp="2t5sdfwx9zvv8" />
              <div className="absolute inset-0 bg-gradient-to-r from-brand-ink/60 via-transparent to-transparent" data-id="element-18" data-mp="2x6vrcdvrjhtt" />
              <div className="relative flex h-full flex-col justify-end p-10 [text-shadow:0_2px_14px_rgba(0,0,0,0.85)]" data-id="element-19" data-mp="2j7cjznas0aik">
                <h2 className="font-heading text-3xl font-bold text-white" data-id="element-20" data-mp="2o9boj0i95dh3">
                  Let's build your outdoor space
                </h2>
                <p className="mt-3 max-w-sm text-white/90" data-id="element-21" data-mp="2e9kut11in2i2">
                  Request a free, no-pressure quote. We'll walk your property and give
                  you an honest plan and price.
                </p>
                <div className="mt-8 space-y-3 text-white" data-id="element-22" data-mp="25hsn2y3vm7h6">
                  <a href={BUSINESS.phoneHref} className="flex items-center gap-3 hover:text-white" data-id="element-23" data-mp="1qjgoglwy0ond">
                    <Phone className="h-5 w-5 text-brand-red" data-id="element-24" data-mp="1vijt4590gsut" />
                    {BUSINESS.phoneDisplay}
                  </a>
                  <a href={BUSINESS.maps} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-white" data-id="element-25" data-mp="1ce6q5eosiky2">
                    <MapPin className="h-5 w-5 text-brand-red" data-id="element-26" data-mp="12on6i6t96n25" />
                    {BUSINESS.region}
                  </a>
                </div>
              </div>
            </div>

            <div className="p-8 sm:p-10" data-id="element-27" data-mp="1vbhlwpb7qw8r">
              <div className="lg:hidden" data-id="element-28" data-mp="1vag8ie6q5xnv">
                <h2 className="font-heading text-2xl font-bold text-brand-ink" data-id="element-29" data-mp="1qdfzpvihqgt2">
                  Get a free quote
                </h2>
                <p className="mt-2 text-muted-foreground" data-id="element-30" data-mp="1lcs40wjbhbsi">
                  Tell us about your project and we'll be in touch.
                </p>
              </div>

              {submitted ? <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} className="flex flex-col items-center justify-center py-16 text-center" data-id="element-31" data-mp="a0rbd6jc137h">
                  <CheckCircle2 className="h-14 w-14 text-brand-red" data-id="element-32" data-mp="2lm9wcju6nyx7" />
                  <h3 className="mt-4 font-heading text-xl font-semibold text-brand-ink" data-id="element-33" data-mp="2lkgmyws6r0li">
                    Thanks — we got it!
                  </h3>
                  <p className="mt-2 max-w-sm text-muted-foreground" data-id="element-34" data-mp="2vdo053t63kw5">
                    We'll reach out shortly to schedule your free estimate. Need us
                    sooner? Call {BUSINESS.phoneDisplay}.
                  </p>
                </motion.div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-35" data-mp="39c48ez6ohjge">
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-36" data-mp="3ebgtpfhwiigv">
                    <Field label="Name" name="name" autoComplete="name" required data-id="element-37" data-mp="3eap72u6a7v2q" />
                    <Field label="Phone" name="phone" type="tel" autoComplete="tel" required data-id="element-38" data-mp="1ezxkczsor86o" />
                  </div>
                  <Field label="Email" name="email" type="email" autoComplete="email" data-id="element-39" data-mp="1jzjxzacfeqg0" />
                  <div data-id="element-40" data-mp="3acq95cc5crow">
                    <label htmlFor="service" className="mb-1.5 block text-sm font-medium text-brand-ink" data-id="element-41" data-mp="3age50i52dq6s">
                      Service needed
                    </label>
                    <select id="service" name="service" className="w-full rounded-lg border border-input bg-background px-3.5 py-2.5 text-sm text-foreground outline-none focus:border-brand-red focus:ring-2 focus:ring-brand-red/20" data-id="element-42" data-mp="3jepuggu72hxn">
                      <option data-id="element-43" data-mp="2mmw0z82rvraz">Artificial turf</option>
                      <option data-id="element-44" data-mp="30hf3rkmmowtt">Pavers & patio</option>
                      <option data-id="element-45" data-mp="30i80dsrvi5y8">Desert landscaping</option>
                      <option data-id="element-46" data-mp="2vovi00dsevdx">Commercial project</option>
                      <option data-id="element-47" data-mp="27zug6vzgmihm">Other</option>
                    </select>
                  </div>
                  <div data-id="element-48" data-mp="23yqz665oeget">
                    <label htmlFor="message" className="mb-1.5 block text-sm font-medium text-brand-ink" data-id="element-49" data-mp="23zahhnz8n6td">
                      Project details
                    </label>
                    <textarea id="message" name="message" rows={4} className="w-full resize-none rounded-lg border border-input bg-background px-3.5 py-2.5 text-sm text-foreground outline-none focus:border-brand-red focus:ring-2 focus:ring-brand-red/20" placeholder="Tell us a little about what you're looking for…" data-id="element-50" data-mp="1ylajcqwm3xhq" />
                  </div>
                  <button type="submit" className="w-full rounded-full bg-brand-red px-6 py-3.5 text-base font-semibold text-white transition-colors hover:bg-brand-red-dark" data-id="element-51" data-mp="2hi283fuxb4t6">
                    Request my free quote
                  </button>
                </form>}
            </div>
          </div>
        </div>
      </div>
    </section>;
}
type FieldProps = {
  label: string;
  name: string;
  type?: string;
  required?: boolean;
  autoComplete?: string;
};
function Field({
  label,
  name,
  type = 'text',
  required,
  autoComplete
}: FieldProps) {
  return <div data-id="element-52" data-mp="2p3ntz6qf4lnw">
      <label htmlFor={name} className="mb-1.5 block text-sm font-medium text-brand-ink" data-id="element-53" data-mp="2p34dzvkbw7ci">
        {label}
        {required && <span className="text-brand-red" data-id="element-54" data-mp="2k3jffm92m10b"> *</span>}
      </label>
      <input id={name} name={name} type={type} required={required} autoComplete={autoComplete} className="w-full rounded-lg border border-input bg-background px-3.5 py-2.5 text-sm text-foreground outline-none focus:border-brand-red focus:ring-2 focus:ring-brand-red/20" data-id="element-55" data-mp="2f5hxj4nds7qf" />
    </div>;
}